import React from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';
import { ReactComponent as WarningIcon } from 'assets/images/warning.svg';

export interface MessageBannerProps {
  children: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
}

function MessageBanner(props: MessageBannerProps) {
  return (
    <div className={clsx(styles.root, props.className)}>
      <div>{props.icon || <WarningIcon />}</div>
      <div className={styles.message}>{props.children} </div>
    </div>
  );
}

export default MessageBanner;
